import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import getQueryParam from 'src/app/utils/getQueryParam';
import { tutorStateAtom } from 'src/app/state/atoms';

/**
 * Hook to get payload related to SME Validation from parent window and save into recoil
 */

function useSMEValidation() {
  const [_, setTutorState] = useRecoilState(tutorStateAtom);

  useEffect(() => {
    setTutorState((prev) => ({
      ...prev,
      isSMEMode: getQueryParam('isSMEMode') === 'true',
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export default useSMEValidation;
